import React from 'react';
import { Form1008Data, ValidationErrors } from '../../types';
import { TextInput, NumberInput, CurrencyInput, Select, SegmentedControl } from '../ui/Inputs';
interface Props {
  data: Form1008Data;
  onChange: (field: keyof Form1008Data, value: any) => void;
  errors: ValidationErrors;
}
export function Section1({
  data,
  onChange,
  errors
}: Props) {
  return <div className="space-y-3" data-id="element-64">
      <div data-id="element-65">
        <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-66">
          Borrower
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-2" data-id="element-67">
          <TextInput label="Borrower Name" value={data.borrowerName} onChange={v => onChange('borrowerName', v)} required error={errors.borrowerName} className="md:col-span-2" data-id="element-68" />
          <NumberInput label="Total # of Borrowers" value={data.totalBorrowers} onChange={v => onChange('totalBorrowers', v)} required error={errors.totalBorrowers} data-id="element-69" />
          <Select label="Occupancy Status" value={data.occupancy} onChange={v => onChange('occupancy', v)} required error={errors.occupancy} options={[{
          label: 'Primary Residence',
          value: 'primary'
        }, {
          label: 'Second Home',
          value: 'second'
        }, {
          label: 'Investment Property',
          value: 'investment'
        }]} data-id="element-70" />
        </div>
      </div>

      <div className="pt-3 border-t border-slate-100" data-id="element-71">
        <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-72">
          Subject Property
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-2" data-id="element-73">
          <TextInput label="Property Address" value={data.propertyAddress} onChange={v => onChange('propertyAddress', v)} required error={errors.propertyAddress} className="md:col-span-2 lg:col-span-3" data-id="element-74" />
          <Select label="Special Property Type" value={data.propertyKind} onChange={v => onChange('propertyKind', v)} helperText="PUD / Co-op / Manufactured — leave blank for detached SFR" options={[{
          label: 'None / blank',
          value: ''
        }, {
          label: 'PUD',
          value: 'pud'
        }, {
          label: 'Co-op',
          value: 'coop'
        }, {
          label: 'Manufactured Housing',
          value: 'manufactured'
        }]} data-id="element-75" />
          <CurrencyInput label="Sales Price" value={data.salesPrice} onChange={v => onChange('salesPrice', v)} required error={errors.salesPrice} data-id="element-76" />
          <CurrencyInput label="Appraised Value" value={data.appraisedValue} onChange={v => onChange('appraisedValue', v)} required error={errors.appraisedValue} data-id="element-77" />
          <Select label="Property Type" value={data.propertyType} onChange={v => onChange('propertyType', v)} required error={errors.propertyType} options={[{
          label: '1 unit',
          value: '1unit'
        }, {
          label: '2 units',
          value: '2units'
        }, {
          label: '3 units',
          value: '3units'
        }, {
          label: '4 units',
          value: '4units'
        }, {
          label: 'Condominium',
          value: 'condo'
        }]} data-id="element-78" />
          <SegmentedControl label="Property Rights" value={data.propertyRights} onChange={v => onChange('propertyRights', v)} required error={errors.propertyRights} options={[{
          label: 'Fee Simple',
          value: 'feeSimple'
        }, {
          label: 'Leasehold',
          value: 'leasehold'
        }]} data-id="element-79" />
        </div>
      </div>

      {data.propertyType === 'condo' && <div className="pt-3 border-t border-slate-100" data-id="element-80">
          <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-81">
            Condominium Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2" data-id="element-82">
            <TextInput label="Project Name" value={data.projectName} onChange={v => onChange('projectName', v)} data-id="element-83" />
            <Select label="Project Classification" value={data.projectClassification} onChange={v => onChange('projectClassification', v)} options={[{
          label: 'E — Established PUD',
          value: 'E'
        }, {
          label: 'F — New PUD',
          value: 'F'
        }, {
          label: 'Q — Ltd Review, Established Condo',
          value: 'Q'
        }, {
          label: 'S — Full Review, Established Condo',
          value: 'S'
        }, {
          label: 'V — Condo Review Waived',
          value: 'V'
        }]} data-id="element-84" />
          </div>
        </div>}
    </div>;
}